import { Component,OnInit } from '@angular/core';
import { Service } from '../../../../class/service';
import { Cookies } from '../../../../class/cookies';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import { Search } from '../../../../class/search';
import { View } from '../../view';
import 'rxjs/add/operator/debounceTime';

@Component({
	selector: 'formatoarchivo-component',
	templateUrl: 'formato-archivo.component.html'
})

export class FormatoArchivoComponent extends View implements OnInit {
	//modelo de datos
	private model: Object = { PK_CodigoPagaduria:'', PK_Tipo: '', };
	//Object con las PK de la tabla, cuando esta no tiene id autonincremental 
    private pk:Object = { PK_CodigoPagaduria:'', PK_Tipo: '' }
	//Referencia a los imput, lo cuales necesitan validacion personalizada
	private PK_CodigoPagaduria = new FormControl();
    private PK_Tipo = new FormControl();
	private existe_pk:boolean = false;

	constructor(public service: Service, public cookies: Cookies) {
		super(service,cookies,"formatoarchivo-component");
		super.serviceNmae("formatoarchivo");
	}

	ngOnInit() {
		super.filter({
			column:[
				{ name: 'PK_CodigoPagaduria', nickname: 'Codigo' },
				{ name: 'PK_Tipo', nickname: 'Tipo' },
				{ name: 'nombreArchivo', nickname: 'Nombre' }
			]
		});

        //Validaciones personalizadas
        this.PK_CodigoPagaduria.valueChanges
			.debounceTime(500)
			.subscribe(a => {
				if (a != null || a != undefined){
					if (a != this.model["PK_CodigoPagaduria"]){
						this.model["PK_CodigoPagaduria"] = a;
						if(this.model["PK_Tipo"] != null || this.model["PK_Tipo"] != undefined){
							if(this.model["PK_CodigoPagaduaria"] != '' && this.model["PK_Tipo"] != ''){
								this.existePk();
							}
						}
					}
				}
			});
		//
		this.PK_Tipo.valueChanges
			.debounceTime(700)
			.subscribe(a => {
				if (a != null || a != undefined){
					if (a != this.model["PK_Tipo"]){
						this.model["PK_Tipo"] = a;
						if(this.model["PK_CodigoPagaduria"] != null || this.model["PK_CodigoPagaduria"] != undefined){
							if(this.model["PK_CodigoPagaduaria"] != '' && this.model["PK_Tipo"] != ''){
								this.existePk();
							}
						}
					}
				}
			});		
	}

	private getData(data:Object):void{
		console.log(data);
	}

	//Un nuevo registro, iniciando datos
	private NEW(): void {
        this.resetComponent();
		this.list = false;
		this.action = 'Guardar';
	}

    private resetComponent():void {
        this.PK_CodigoPagaduria.reset();
        this.PK_Tipo.reset();
        this.model = { PK_CodigoPagaduria:'', PK_Tipo: '' };
    }

	//Editar en base al codigo de referencia
	private EDIT(pk_: Object): void {
		this.pk = pk_;
		this.action = "Actualizar";
		this.list = false;
		this.getModelById();
	}

	//Para obtener y cargar el registro seleccionado
	private getModelById(): void {
		this.state = !this.state;
		this.service
        .GET('formatoarchivo/' + this.pk["PK_CodigoPagaduria"]+"/" + this.pk["PK_Tipo"], '')
        .subscribe(res => {
			this.model = res["show"][0];
			this.state = !this.state;
		}, err => {
			console.log(err);
			this.state = !this.state;
		});
	}

	//Validar si guardar o modificar
	private actionCrud(): void {
		if (this.action.toUpperCase() == "GUARDAR") {
			this.save();
		} else {
			this.update();
		}
	}

	//Para eliminar el registro
	private DELETE(pk_: Object): void {
		this.state = !this.state;
		this.service.DELETE('formatoarchivo/' + pk_["PK_CodigoPagaduria"]+"/"+pk_["PK_Tipo"]).subscribe(res => {
			this.getList(this.pagination["current_page"], "");
			if (res["destroy"]) {
				this.openMd("El registro se elimino correctamente", "success");
			} else {
				this.openMd("El registro no se elimino", "danger");
			}
			this.state = !this.state;
		}, err => {
			console.log(err);
			this.state = !this.state;
			this.openMd(err, "danger");
		});
	}

	//Guardar el registro
	private save(): void {
		this.state = !this.state;
		console.log({ data: JSON.stringify(this.model) });
		this.service.POST('formatoarchivo', { data: JSON.stringify(this.model) }).subscribe(res => {
			this.state = !this.state;
			this.list = !this.list;
			this.getList(1, "");
            this.openMd('Registro guardado corectamente','success');
		}, err => {
            this.openMd(err,'danger');
			this.state = !this.state;
		});
	}

	//Modificar el registro
	private update(): void {
		this.state = !this.state;
		this.service
        .PUT('formatoarchivo/' + this.pk["PK_CodigoPagaduria"]+"/"+this.pk["PK_Tipo"], { data: JSON.stringify(this.model) })
        .subscribe(res => {			
			if (res["update"]) {
				this.state = !this.state;
				this.getList(1,"");
				this.openMd("El registro se ha modificado correctamente", "success");
				this.list = !this.list;
			} else {
				this.openMd("El registro no se ha podido modificar", "danger");
			}
		}, err => {
			console.log(err);
		});
	}

	private existePk():void{
		this.service.POST('formatoarchivo/existePk',{ PK_CodigoPagaduria:this.model["PK_CodigoPagaduria"], PK_Tipo:this.model["PK_Tipo"] })
		.subscribe(res => {
			this.existe_pk = res["existePk"];
			
		},err => {
			this.openMd(err,'danger');
		});
	}

	

}



// WEBPACK FOOTER //
// ./src/app/component/module/archivo/formato-archivo/formato-archivo.component.ts